import { render, staticRenderFns } from "./MonitoringPatientsCharts.vue?vue&type=template&id=4582fe1a&scoped=true"
import script from "./MonitoringPatientsCharts.vue?vue&type=script&lang=js"
export * from "./MonitoringPatientsCharts.vue?vue&type=script&lang=js"
import style0 from "./MonitoringPatientsCharts.vue?vue&type=style&index=0&id=4582fe1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4582fe1a",
  null
  
)

export default component.exports